function createOverlay(image) {
  const overlayImage = document.createElement("img");
  overlayImage.setAttribute("src", `${image.src}`);
  overlay = document.createElement("div");
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = "50%";
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = "100%";
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute("class", "image-magnify-full-size");
  container.setAttribute("aria-hidden", "true");
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = "var(--gradient-background)";
}

function toggleLoadingSpinner(image) {
  const loadingSpinner =
    image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle("hidden");
}

function moveWithHover(image, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => { overlay.remove(); openFullscreen(image); };
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

// ── Fullscreen viewer ──────────────────────────────────────────
function openFullscreen(image) {
  const viewer = document.createElement("div");
  viewer.className = "image-magnify-fullscreen";
  viewer.setAttribute("aria-modal", "true");
  viewer.setAttribute("role", "dialog");

  const img = document.createElement("img");
  img.src = image.src;
  img.className = "image-magnify-fullscreen__img";
  img.alt = image.alt || "";

  const close = document.createElement("button");
  close.className = "image-magnify-fullscreen__close";
  close.setAttribute("aria-label", "Close");
  close.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

  viewer.appendChild(img);
  viewer.appendChild(close);
  document.body.appendChild(viewer);
  document.body.classList.add("image-magnify-fullscreen-open");

  requestAnimationFrame(() => viewer.classList.add("is-open"));

  function closeViewer() {
    viewer.classList.remove("is-open");
    viewer.addEventListener(
      "transitionend",
      () => {
        viewer.remove();
        document.body.classList.remove("image-magnify-fullscreen-open");
      },
      { once: true },
    );
  }

  close.onclick = closeViewer;
  viewer.onclick = (e) => {
    if (e.target === viewer) closeViewer();
  };

  const onKey = (e) => {
    if (e.key === "Escape") {
      closeViewer();
      document.removeEventListener("keydown", onKey);
    }
  };
  document.addEventListener("keydown", onKey);
}

// ── Init ───────────────────────────────────────────────────────
function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll(".image-magnify-hover");
  images.forEach((image) => {
    image.addEventListener("mouseenter", (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    });

    image.addEventListener("click", () => openFullscreen(image));
  });
}

enableZoomOnHover(2);